export default "__VITE_ASSET__4a1136f8__"